import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Box,
  Button,
} from "@mui/material";
import { Settings as SettingsIcon, AdminPanelSettings as AdminIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function TopBar({ user, isAdmin }) {
  const navigate = useNavigate();

  return (
    <AppBar position="static" sx={{ mb: 3 }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 700 }}>
          🏢 Enterprise Portal
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {isAdmin && (
            <Button
              color="inherit"
              startIcon={<AdminIcon />}
              onClick={() => navigate("/admin")}
              sx={{ textTransform: "none" }}
            >
              Admin
            </Button>
          )}

          <IconButton color="inherit" onClick={() => navigate("/settings")}>
            <SettingsIcon />
          </IconButton>

          {user && (
            <Avatar
              alt={user.displayName || user.email}
              src={user.photoURL}
              sx={{ width: 32, height: 32, cursor: "pointer" }}
              onClick={() => navigate("/profile")}
            />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
